import { Box, TableCell, TableRow } from '@mui/material'
import Loading from 'components/global/Loading'
import React from 'react'

const NoContent = ({ children, colSpan = 1 }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>{children}</Box>
      </TableCell>
    </TableRow>
  )
}

const TableRowLoading = ({colSpan}) => {
  return (<NoContent colSpan={colSpan}><Loading/></NoContent>)
}

export default TableRowLoading
